export const COVER_CATEGORY_OPTIONS = [
  { value: 'merry-christmas', text: 'Merry Christmas' },
  { value: 'birthday', text: 'Birthday' },
  { value: 'thank-you', text: 'Thank You' },
  { value: 'in-memory', text: 'In Memory' },
  { value: 'easter', text: 'Easter' },
  { value: 'mothers-day', text: "Mother's Day" },
  { value: 'fathers-day', text: "Father's Day" },
  { value: 'in-your-honor', text: 'In Your Honor' },
  { value: 'thinking-of-you', text: 'Thinking of You' },
] as const;

export const COVER_CATEGORIES = COVER_CATEGORY_OPTIONS.map(
  (c) => c.value,
) as unknown as readonly [
  (typeof COVER_CATEGORY_OPTIONS)[number]['value'],
  ...(typeof COVER_CATEGORY_OPTIONS)[number]['value'][],
];

export type CoverCategory = (typeof COVER_CATEGORY_OPTIONS)[number]['value'];

export const GIFT_IDS = [
  'gift-of-impact',
  '12-month-apprenticeship',
  'art-classes',
  'babys-medical-care',
  'baking-classes',
  'bathrooms-hygiene-training',
  'bibles',
  'birth-attendant',
  'business-tech-bundle',
  'business-skills',
  'chickens',
  'computers',
  'cows',
  'dental-kit',
  'disaster-relief-bundle',
  'electricity-at-compassion-center',
  'emergency-bottled-water',
  'emergency-food-packs',
  'english-skills',
  'food-for-baby-mother',
  'food-for-malnourished-child',
  'fruit-trees',
  'goats',
  'hiv-aids-care',
  'health-bundle',
  'help-babies-reach-1st-birthday',
  'help-a-girl-at-risk',
  'home-repair',
  'hunger-relief-bundle',
  'hygiene-kit',
  'income-generation-bundle',
  'lifesaving-surgery',
  'long-term-shelter',
  'meet-an-urgent-need',
  'mind-body-soul-bundle',
  'mosquito-net',
  'music-lessons',
  'newborn-bundle',
  'newborn-care-package',
  'pigs',
  'protection-from-parasites',
  'rescue-from-dangerous-situation',
  'stem-skills',
  'safe-playground',
  'send-compassion-kid-to-college',
  'sewing-workshop',
  'small-business-startup-recovery',
  'spiritual-leadership-formation',
  'sports-camps',
  'textbooks',
  'the-ark-bundle',
  'unsponsored-children',
  'urgent-medical-care',
  'vaccinations',
  'vegetable-seeds',
  'water-bundle',
  'water-filter',
  'water-wells',
  'where-most-needed',
] as const;

export type GiftId = (typeof GIFT_IDS)[number];
